import { z } from 'zod';

import { commonErrors } from '@utils/error';
import { checkbox, optionalString, requiredString } from '@utils/validation';

export const schema = z
	.object({
		affirmingFirstName: requiredString(commonErrors.responseRequired),
		affirmingLastName: requiredString(commonErrors.responseRequired),
		legalFirstName: optionalString,
		legalLastName: optionalString,
		sameLegalName: checkbox,
	})
	.refine(
		(input) => {
			if (!(input.legalFirstName && input.legalLastName)) {
				return input.sameLegalName;
			} else {
				return true;
			}
		},
		{
			message:
				'Please attest that your legal name is the same as provided above or enter it below.',
			path: ['sameLegalName'],
		}
	);
